<template>
  <div class="info-box">
    <div v-if="contentType == 'event'">
      <div class="info-row">
        <div class="info-section teams" v-if="video.teams.length">
          <h5 class="info-heading">Teams</h5>
          <p>
            <span v-for="(team, index) in video.teams" :key="team.name">
              {{ team.name
              }}<span v-if="index !== video.teams.length - 1">, </span>
            </span>
          </p>
        </div>
        <div class="info-section field" v-if="video.field">
          <h5 class="info-heading">Field</h5>
          <p>
            {{ video.field.name }}
          </p>
        </div>
        <div class="info-section date" v-if="video.date">
          <h5 class="info-heading">Date</h5>
          <p>
            {{ video.date }}
          </p>
        </div>
      </div>

      <div class="info-row game-events" v-if="gameEvents.length">
        <h5 class="info-heading">Game Events</h5>
        <div class="game-event-cols">
          <span
            class="internalLink"
            v-for="gameEvent in gameEvents"
            :key="gameEvent.title"
            v-on:click="gotoGameEvent(gameEvent.position)"
          >
            {{ gameEvent.title }}
          </span>
        </div>
      </div>
    </div>

    <div v-else-if="contentType == 'hilite'">
      <div class="info-row">
        <div class="info-section event">
          <h5 class="info-heading">Event</h5>
          <span class="internalLink" v-on:click="loadParentEvent(parent)">{{ parent.title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoBox",
  props: ["video"],
  computed: {
    gameEvents: {
      get() {
        return this.video.gameEvents;
      }
    },
    jumpPosition: {
      get() {
        return this.$store.state.player.jumpPosition;
      },
      set(value) {
        this.$store.state.player.jumpPosition = value;
      }
    },
    contentType: {
      get() {
        return this.$store.state.player.contentType;
      }
    },
    parent: {
      get() {
        return this.$store.state.parentEvent;
      }
    }
  },
  methods: {
    loadParentEvent(parent) {
      this.$store.commit("setEvent", parent);
    },
    gotoGameEvent(position) {
      this.jumpPosition = position;
    }
  }
};
</script>

<style lang="stylus" scoped>
.info-box
  width: 100%
  background: #F9F9F9
  padding: 30px
  margin-top: 25px
  @media screen and (max-width: mobile-landscape)
    padding: 15px
    margin-top: 15px
  .info-heading
    margin: 0px 0px 5px 0px
    fluid font-size 16 14
    border-bottom: 2px solid #EBEBEB
    color: #001249
  .info-row
    display: flex
    margin-bottom: 20px
    .info-section
      margin-right: 20px
    &.game-events
      flex-wrap: wrap
    &:last-of-type
      margin-bottom: 0px
  .game-event-cols
    width: 100%
    column-width: 150px
  span.internalLink
    width: 100%
    display: block
    cursor: pointer
    text-decoration: underline
    color: inherit
  p, span, a
    color: inherit
    margin: 0px
    fluid font-size 16 14
</style>
